/* AUTH */

export const AUTH_TYPE_AUTHORIZED = 'AUTH_TYPE_AUTHORIZED';
export const AUTH_TYPE_GUEST = 'AUTH_TYPE_GUEST';

/* ROLES */

export const ROLE_TYPE_ADMIN = 'admin';
export const ROLE_TYPE_PROVIDER = 'provider';
